/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAlertRequirementPeriod;
(function (ApiAlertRequirementPeriod) {
    ApiAlertRequirementPeriod["PREVIOUS"] = "CONDITION_PERIOD_PREVIOUS";
    ApiAlertRequirementPeriod["PREVIOUS_MONTH"] = "CONDITION_PERIOD_PREVIOUS_MONTH";
    ApiAlertRequirementPeriod["PREVIOUS_YEAR"] = "CONDITION_PERIOD_PREVIOUS_YEAR";
})(ApiAlertRequirementPeriod || (ApiAlertRequirementPeriod = {}));
export function ApiAlertRequirementPeriodFromJSON(json) {
    return ApiAlertRequirementPeriodFromJSONTyped(json, false);
}
export function ApiAlertRequirementPeriodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAlertRequirementPeriodToJSON(value) {
    return value;
}
